<cb-display-value-new [label]="label" [value]="displayText"></cb-display-value-new>
